import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, CopyToClipboard, FlexBox, Text, } from '@dixa/lib-shared-habla';
import { CodeHighlight } from 'components/codeHighlight';
import { DocumentationLink } from '../documentationLink/documentationLink';
export function WebSetup({ messengerToken }) {
    const embedCode = getEmbedCode(messengerToken);
    return (_jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "300" }, { children: [_jsx(Text.Paragraph, Object.assign({ variant: "3", subdued: true }, { children: "Script" })), _jsx(CodeHighlight, Object.assign({ languages: ['js', 'html'] }, { children: embedCode })), _jsx(DocumentationLink, {}), _jsx(Box, { children: _jsx(CopyToClipboard, Object.assign({ textToCopy: embedCode }, { children: _jsx(Button, Object.assign({ icon: "copy" }, { children: "Copy script" })) })) })] })));
}
function getEmbedCode(messengerToken) {
    return `<script>
(function (w, d, s) {
  if (w._dixa_) return;
  w._dixa_ = {
    invoke: function (m, a) {
      w._dixa_.pendingCalls = w._dixa_.pendingCalls || [];
      w._dixa_.pendingCalls.push([m, a]);
    },
    addListener: function (event, listener) {
      w._dixa_.pendingAddListenerCalls = w._dixa_.pendingAddListenerCalls || [];
      w._dixa_.pendingAddListenerCalls.push([event, listener]);
    },
  };
  s = d.createElement('script');
  s.type = 'text/javascript';
  s.setAttribute('charset', 'utf-8');
  s.async = true;
  s.src = 'https://messenger.dixa.io/bootstrap.js';
  var before = d.getElementsByTagName('script')[0];
  before.parentNode.insertBefore(s, before);
})(window, document);
_dixa_.invoke('init', { messengerToken: '${messengerToken}' });
</script>`;
}
